/**
 * Todo API
 * @class google.API
 * @memberof google
 */
export class API {
    /**
     * todo
     * @returns {string}
     */
    static get key() {
        return this._key;
    }
    /**
     * todo
     * @param {string} value
     */
    static set key(value) {
        this._key = value;
    }
}
/**
 * todo
 * @type {string}
 * @private
 */
API._key = '';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVBJLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2dvb2dsZS9BUEkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUNILE1BQU0sT0FBTyxHQUFHO0lBQ1o7OztPQUdHO0lBQ0gsTUFBTSxLQUFLLEdBQUc7UUFDVixPQUFPLElBQUksQ0FBQyxJQUFJLENBQUE7SUFDcEIsQ0FBQztJQUVEOzs7T0FHRztJQUNILE1BQU0sS0FBSyxHQUFHLENBQUUsS0FBYTtRQUN6QixJQUFJLENBQUMsSUFBSSxHQUFHLEtBQUssQ0FBQTtJQUNyQixDQUFDOztBQUVEOzs7O0dBSUc7QUFDWSxRQUFJLEdBQVcsRUFBRSxDQUFBIn0=